import { gql } from '@apollo/client'

export default gql`
  mutation remove_colleague_from_project($id: ID!) {
    remove_colleague_from_project(id: $id) {
      id
    }
  }
`
